import React from 'react';
import { Bot, Sparkles } from 'lucide-react';
interface AgentAvatarProps {
  size?: 'sm' | 'md' | 'lg';
  thinking?: boolean;
  className?: string;
}
export function AgentAvatar({
  size = 'md',
  thinking = false,
  className = ''
}: AgentAvatarProps) {
  const sizeClasses = {
    sm: 'w-8 h-8',
    md: 'w-10 h-10',
    lg: 'w-16 h-16'
  };
  const iconSizes = {
    sm: 'w-4 h-4',
    md: 'w-5 h-5',
    lg: 'w-8 h-8'
  };
  return <div className={`relative ${className}`} data-id="element-1793">
      {/* LED glow effect when thinking — subtle pulse, no ping */}
      {thinking && <div className={`absolute -inset-1.5 rounded-full bg-indigo-500/25 animate-pulse blur-md`} data-id="element-1794" />}

      <div className={`relative flex items-center justify-center rounded-full bg-gradient-to-br from-indigo-600 to-violet-600 text-white shadow-lg ${thinking ? 'shadow-indigo-500/50 ring-2 ring-indigo-400/60' : 'shadow-indigo-900/30'} ${sizeClasses[size]}`} data-id="element-1795">
        {thinking ? <Sparkles className={`${iconSizes[size]} animate-pulse`} data-id="element-1796" /> : <Bot className={iconSizes[size]} data-id="element-1797" />}
      </div>

      {/* Status indicator dot */}
      {!thinking && <span className="absolute bottom-0 right-0 block h-2.5 w-2.5 rounded-full bg-emerald-500 ring-2 ring-slate-900" data-id="element-1798" />}
    </div>;
}